import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';

import { PipelineService } from '@app/core/pipelines/services/pipeline.service';
import { RfqService } from '@app/core/quotes';

@Component({
  selector: 'cnc-np-tags-popup',
  templateUrl: './np-tags-popup.component.html',
  styleUrls: ['./np-tags-popup.component.scss'],
})
export class NpTagsPopupComponent implements OnInit {
  pageTitle :string = 'Set SKU Tags';
  pipelines :any[] = [];
  rfqPipelines :any[] = [];
  loading :boolean;

  @Input() rfq :any;

  constructor(
    public activeModal :NgbActiveModal,
    public pipelineSvc :PipelineService,
    private rfqSvc :RfqService,
    private toastr :ToastrService,
  ) {}

  ngOnInit() {
    console.log(this.rfq);
  }

  setTags() {}
}
